import { Component, OnInit, Inject } from '@angular/core';
import { HomeComponent } from 'src/app/home/home.component';

@Component({
  selector: 'app-right-menu-button',
  templateUrl: './right-menu-button.component.html',
  styleUrls: ['./right-menu-button.component.css']
})
export class RightMenuButtonComponent implements OnInit {

  constructor(@Inject(HomeComponent) private home: HomeComponent) { }

  ngOnInit() {
  }
  openRightMenuDrawer() {
    this.home.openRightMenu();
  }

}
